export default __webpack_public_path__ + "static/media/MONITO DEL MONTE_Cuento con titeres.7dd4049d.jpeg";